<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentFollowUp.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: 'Home', href: '/' },
          {
            text: $t('studentFollowUp.pageTitle'),
            href: '/student-follow-ups'
          },
          { text: $t('create'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-2">
            <label class="required">Action Date</label>
            <ts-date-picker-input v-model="model.action_date" />
            <div class="validate" v-if="errors.has('action_date')">
              {{ errors.first('action_date') }}
            </div>
          </div>
          <div class="col-md-2">
            <label class="required">Assign To</label>
            <a-select
              v-model="model.responsible_by"
              :options="responsibleLists"
              :show-search="true"
              :filter-option="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              class="ts-w-full"
            ></a-select>
            <div class="validate" v-if="errors.has('responsible_by')">
              {{ errors.first('responsible_by') }}
            </div>
          </div>
        </div>
        <div class="ts-flex ts-mt-2">
          <div style="width: 48.5%" class="ts-border ts-rounded-md ts-p-3">
            <ts-input
              class="form-control d-block mb-2"
              v-model="searchStudentTextLeftSide"
              :placeholder="$t('search')"
            />
            <div
              class="overflow-auto"
              style="max-height: 1vh; min-height: 500px"
            >
              <ts-table
                :loading="loading"
                :columns="columns"
                :records="availableStudentsLeftSide"
              >
                <template v-slot="{ record }">
                  <td>
                    <ts-checkbox
                      :value="record.inquiry_id"
                      v-model="selectedStudentIdLeftSide"
                    ></ts-checkbox>
                  </td>
                  <td class="ts-whitespace-no-wrap">
                    {{ record.created_date }}
                  </td>
                  <td class="ts-whitespace-no-wrap">
                    {{ record.full_name_en }}
                  </td>
                  <td class="text-center ts-whitespace-no-wrap">
                    {{ record.gender }}
                  </td>
                  <td class="ts-whitespace-no-wrap">
                    {{ record.contact_name }}
                  </td>
                  <td class="text-center ts-whitespace-no-wrap">
                    {{ record.contact_number }}
                  </td>
                  <td class="text-center ts-whitespace-no-wrap">
                    {{
                      record.sub_program
                        ? record.sub_program.acps_name_foreign
                        : ''
                    }}
                  </td>
                </template>
              </ts-table>
            </div>
          </div>
          <div class="ts-flex ts-items-center ts-mx-2">
            <div class="ts-h-24 ts-space-y-3 ts-flex-none">
              <button
                class="ts-px-3 ts-py-1 ts-rounded focus:ts-outline-none"
                :class="
                  selectedStudentIdLeftSide.length <= 0
                    ? 'ts-bg-gray-300 '
                    : 'ts-bg-blue-400 ts-text-white'
                "
                @click.prevent="selectedItemToRightSide"
                :disabled="selectedStudentIdLeftSide.length <= 0"
              >
                <i class="fas fa-chevron-right"></i>
              </button>
              <br />
              <button
                class="ts-px-3 ts-py-1 ts-rounded focus:ts-outline-none"
                :class="
                  selectedStudentIdRightSide.length <= 0
                    ? 'ts-bg-gray-300'
                    : 'ts-bg-blue-400 ts-text-white'
                "
                @click.prevent="selectedItemToLeftSide"
                :disabled="selectedStudentIdRightSide.length <= 0"
              >
                <i class="fas fa-chevron-left"></i>
              </button>
            </div>
          </div>
          <div class="ts-border ts-rounded-md ts-p-3" style="width: 48.5%">
            <ts-card>
              <ts-input
                class="form-control d-block mb-2"
                v-model="searchStudentTextRightSide"
                :placeholder="$t('search')"
              />
              <div
                class="overflow-auto"
                style="max-height: 1vh; min-height: 500px"
              >
                <ts-table
                  :loading="loading"
                  :columns="columns"
                  :records="availableStudentRightSide"
                >
                  <template v-slot="{ record }">
                    <td>
                      <ts-checkbox
                        :value="record.inquiry_id"
                        v-model="selectedStudentIdRightSide"
                      ></ts-checkbox>
                    </td>
                    <td>{{ record.created_date }}</td>
                    <td>{{ record.full_name_en }}</td>
                    <td class="text-center">{{ record.gender }}</td>
                    <td>{{ record.contact_name }}</td>
                    <td class="text-center">{{ record.contact_number }}</td>
                  </template>
                </ts-table>
              </div>
              <ts-card-wrapper>
                <div class="validate" v-if="errors.has('inquiry_id_list')">
                  {{ errors.first('inquiry_id_list') }}
                </div>
              </ts-card-wrapper>
            </ts-card>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right mt-2">
            <ts-button
              class="mr-2"
              @click.prevent="$router.push({ name: 'student-follow-up' })"
              >Cancel</ts-button
            >
            <ts-button
              color="primary"
              outline
              :waiting="waiting_save_add_new"
              @click.prevent="saveAddNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              class="ml-2"
              color="primary"
              :waiting="waiting"
              @click.prevent="save"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'student-follow-up-create',
  data () {
    return {
      model: {
        seletedStudentIds: [],
        responsible_by: null,
        action_date: moment().format('DD-MM-YYYY')
      },
      StudentsLeftSide: [],
      selectedStudentIdLeftSide: [],
      selectedStudentIdRightSide: [],
      errors: new Errors(),
      loading: false,
      waiting: false,
      waiting_save_add_new: false,
      searchStudentTextLeftSide: '',
      searchStudentTextRightSide: ''
    }
  },
  created () {
    this.fetchStudentInquiry()
  },
  computed: {
    ...mapState('studentFollowUp', ['infoInquiries', 'employees']),

    responsibleLists () {
      if (this.employees.length > 0) {
        return this.employees.map(el => ({
          value: el.staff_id,
          label: el.name_en
        }))
      }
      return []
    },
    columns () {
      return [
        {
          name: this.$t('')
        },
        {
          name: this.$t('infoinquiry.date'),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.nameEn'
          ),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.gender'
          ),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.contactName'
          ),
          style: 'white-space: nowrap;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.contactNumber'
          ),
          style: 'text-align:center;white-space: nowrap;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.program'
          ),
          style: 'text-align:center;white-space: nowrap;'
        }
      ]
    },
    availableStudentsLeftSide () {
      return this.StudentsLeftSide.filter(p => {
        let excluded = !_.includes(
          this.model.seletedStudentIds.map(_p => _p),
          p.inquiry_id
        )

        if (this.searchStudentTextLeftSide.trim() !== '') {
          return (
            p.full_name_en
              .toLowerCase()
              .includes(this.searchStudentTextLeftSide.toLowerCase().trim()) &&
            excluded
          )
        }

        return excluded
      })
    },

    availableStudentRightSide () {
      return this.infoInquiries.filter(p => {
        let included = _.includes(
          this.model.seletedStudentIds.map(_p => _p),
          p.inquiry_id
        )

        if (this.searchStudentTextRightSide.trim() !== '') {
          return (
            p.full_name_en
              .toLowerCase()
              .includes(this.searchStudentTextRightSide.toLowerCase().trim()) &&
            included
          )
        }

        return included
      })
    }
  },
  methods: {
    fetchStudentInquiry (attributes) {
      this.loading = true
      this.$store
        .dispatch('studentFollowUp/fetchInfoInquiries', attributes)
        .then(response => {
          this.studentInquiries = response
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })

      this.$store
        .dispatch('studentFollowUp/fetchEmployees')
        .then(response => {})
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loadingCashier = false
        })
    },
    selectedItemToRightSide () {
      this.selectedStudentIdRightSide = []
      this.selectedStudentIdLeftSide.map(p =>
        this.model.seletedStudentIds.push(p)
      )
      this.selectedStudentIdLeftSide = []
    },

    allItemToRightSide () {
      this.selectedStudentIdRightSide = []
      this.model.seletedStudentIds = this.StudentsLeftSide.map(
        p => p.inquiry_id
      )
    },

    selectedItemToLeftSide () {
      this.selectedStudentIdLeftSide = []
      this.selectedStudentIdRightSide.map(el => {
        this.model.seletedStudentIds.splice(
          this.model.seletedStudentIds.indexOf(el),
          1
        )
      })
      this.selectedStudentIdRightSide = []
    },

    allItemToLeftSide () {
      this.selectedStudentIdLeftSide = []
      this.model.seletedStudentIds = []
    },

    clear () {
      ;(this.StudentsLeftSide = []),
        (this.selectedStudentIdLeftSide = []),
        (this.selectedStudentIdRightSide = []),
        (this.model.seletedStudentIds = [])
    },

    clearForm () {
      ;(this.StudentsLeftSide = []),
        (this.selectedStudentIdLeftSide = []),
        (this.selectedStudentIdRightSide = []),
        (this.model.seletedStudentIds = []),
        (this.model.location_id = '')
    },

    async save () {
      this.errors = new Errors()
      this.waiting = true

      this.$store
        .dispatch('studentFollowUp/store', this.model)
        .then(response => {
          this.clearForm()
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'student-follow-up' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async saveAddNew () {
      this.errors = new Errors()
      this.waiting_save_add_new = true

      this.$store
        .dispatch('studentFollowUp/store', this.model)
        .then(response => {
          this.clearForm()
          this.waiting_save_add_new = false
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.waiting_save_add_new = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    infoInquiries: {
      handler (val) {
        if (_.isEqual(val)) return
        this.StudentsLeftSide = val
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'student-follow-up') {
      this.$store.commit('studentFollowUp/SET_INFO_INQUIRIES', [])
    }
    next()
  }
}
</script>
